import { SecureDocument } from './secureDocument';

export class MailRequest {
    public ResourceKeys : Array<string> = new Array<string>();
    public ResourceType : string = "doc";
}

// MailResource Represents a single document to be mailed, it could be an image or a pdf document
export class MailResource  {
	Title : string;
	URL : string;
	ResourceType : string;
}

// MailRequestEx struct carries both the key and the title of the document
export class MailRequestEx {
	MailResources : Array<MailResource> = new Array<MailResource>();
}


